import { Table } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

export const TablePlaceholderStyle = styled(Table)<LayoutProps & SpaceProps>`
  ${layout};
  ${space};
`;

export const TablePlaceholderAnimation = styled.div`
  background: ${tokens.colors.grayLight};
  border-radius: ${tokens.radii.s};
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeholderAnimation;
  animation-timing-function: linear;
  background: linear-gradient(
    to right,
    rgba(149, 149, 149, 0.1) 8%,
    rgba(149, 149, 149, 0.2) 18%,
    rgba(149, 149, 149, 0.1) 33%
  );
  background-size: 1260px 170px;
  width: 90%;
  height: ${tokens.space.large};

  @keyframes placeholderAnimation {
    0% {
      background-position: -468px 0;
    }

    100% {
      background-position: 468px 0;
    }
  }
`;
